import React, {ReactNode} from 'react';

import cs from 'classnames';

import {DocumentIcon} from 'app/notifly/components/DocumentIconWithNotifications';
import {getObjectName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import type {BaseActionableDocumentType} from 'app/general/types';

type Props = {
  color: 'success' | 'warning' | 'info';
  iconClasses: string;
  mainMessage: string;
  document: BaseActionableDocumentType;
  additionalContent?: ReactNode;
};

export function MainStatusCard({
  color,
  iconClasses,
  mainMessage,
  document,
  additionalContent,
}: Props) {
  return (
    <div className={cs('px-0 pt-2 pb-3 border-bottom mb-2')}>
      <div className="d-flex">
        <h4
          className={cs(
            'fa fa-fw mr-2 mt-1',
            color ? `text-${color}` : null,
            iconClasses
          )}
        />
        <div>
          <div></div>
          {gt(mainMessage, {
            document: (
              <div className="font-weight-bold d-block">
                <DocumentIcon
                  className="mr-1"
                  contentType={document.content_type}
                />
                {getObjectName(document, document.content_type, true)}
              </div>
            ),
          })}
          {additionalContent != null ? <div>{additionalContent}</div> : null}
        </div>
      </div>
    </div>
  );
}
